import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ user, redirectPath, children }) => {
  
  if (!user || !(user && user.roles && user.roles[0] && user.roles[0].role === "ROLE_MEMBER") || !user.emailVerified) {
    return <Navigate to={redirectPath} replace />;
  }
  return children;
};

export const ProtectedUserRoute = ({ user, redirectPath, children }) => {
  if (!user) {
    return <Navigate to={redirectPath} replace />;
  }
  return children;
};

export const ProtectedSupplierRoute = ({ user, redirectPath, children }) => {
  if (!user || !(user && user.roles[0].role === "ROLE_PARTNER")) {
    return <Navigate to={redirectPath} replace />;
  }
  return children;
};

export const ProtectedAdminRoute = ({ user, redirectPath, children }) => {
  if (!user || !(user && user.roles[0].role === "ROLE_ADMIN")) {
    return <Navigate to={redirectPath} replace />;
  }
  return children;
};

export const ProtectedShipperRoute = ({ user, redirectPath, children }) => {
  if (!user || !(user && user.roles[0].role === "ROLE_SHIPPER")) {
    return <Navigate to={redirectPath} replace />;
  }
  return children;
};